import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  width: 100%;
  display: flex;
  flex-direction: column;
`

export const SubTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const LabelCompany = styled.label`
  overflow: hidden;
  color: var(--foreground-neutral-faded, #4d5874);

  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`

export const AddCommentContainer = styled.div`
  width: 100%;

  & > div {
    padding: 16px;
  }
`

export const DatePickerInput = styled.div`
  position: relative;
`

export const DatePickerContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`
